export class Image {
  id?: number;
  model_id: number;
  url: string;
  main: boolean;
  type: string;
}
